<template>
  <div id="Cookie-Banner" class="Cookie" :class="class_root">
    <div class="Cookie--message">
        <span>En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies
        conformément à notre politique de données personnelles, <router-link to="/politique-confidentialite"
                                                                             @click.native="$scrollToTop();">en savoir plus.</router-link></span>


    </div>
    <div class="Cookie--button">
      <div @click="accept" class="Cookie--buttonAccept Button">
        <img class="Cookie--buttonAcceptImg" src="/img/cookie/cookie.svg" alt="cookie icon"/>
        <div class="Cookie--buttonAcceptText">Accepter tous les cookies</div>
      </div>
    </div>
    <div @click="refuse" class="Cookie-Button-Refuse">
      <a>
        <img src="/img/global/cog.svg" alt="cog icon"/>
        <p>Refuser tous les cookies</p>
      </a>
    </div>
  </div>
</template>

<script>
import {ListenerRegister} from "@bbx/listener~master/core/delta/ListenerRegister";
import {EVENT} from "../../constant/EVENT";
import {eventService} from "../../service/eventService";

export default {
  name: "Cookie",
  data() {
    return {
      events: [],
      state: {
        displayed: false,
      },
    }
  },
  computed: {
    class_root() {
      const classes = []
      if (this.state.displayed) classes.push(`Cookie-displayed`)
      return classes
    }
  },
  mounted() {
    let cookie = this.getCookie();
    if (cookie) {
      this.hideCookie();
    }
  },
  beforeMount() {
    this.events.push(new ListenerRegister({
      name: EVENT.START_ANIMATION,
      callback: () => {
        setTimeout(() => this.state.displayed = true, 500)
      }
    }))

    // -----

    for (const event of this.events) {
      eventService.register(event)
    }
  },
  beforeDestroy() {
    for (const event of this.events) {
      eventService.unregister(event)
    }
  },
  methods: {
    accept() {
      this.setCookie(true);
      this.hideCookie();
    },
    refuse() {
      this.setCookie(false);
      this.hideCookie();
    },
    hideCookie() {
      document.getElementById('Cookie-Banner').style.display = "none";
    },
    setCookie(bool) {
      this.$cookie.set("RGPD", bool, 3);
    },
    getCookie() {
      return this.$cookie.get("RGPD");
    }
  }
}
</script>

<style scoped>
/*
 * * * * * * * * * *
 *
 *  GLOBAL
 *
 * * * * * * * * * *
 */
.Cookie {
  z-index: 9;
  position: fixed;
  left: 50%;
  bottom: 30px;
  max-width: 475px;

  margin-left: -282px; /* width and padding */
  padding: 20px 50px;

  background-color: #FFFFFF;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 10px 30px 5px rgba(119, 119, 119, 0.1);

  opacity: 0;
  transform: translateY(100%);

  transition: transform 500ms, opacity 500ms;
}

.Cookie-displayed {
  transform: translateY(0%);
  opacity: 1;
}

/*
 * * * * * * * * * *
 *
 *   BUTTON - ACCEPT
 *
 * * * * * * * * * *
 */

.Cookie--button {
  display: flex;
  padding: 20px;
  justify-content: center;
}

.Cookie--buttonAccept {
  display: flex;
  align-items: center;
  padding: 10px 30px;
  box-shadow: none;
}

.Cookie--buttonAcceptImg {
  position: relative;
  top: -1px;
  margin-right: 20px;
  width: 20px;
  height: 20px;
}

.Cookie--buttonAcceptText {
  font-family: 'GothamBold', sans-serif;
  font-size: 10px;
  line-height: 10px;
}

.Cookie--message {
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
  font-size: 12px;
  padding: 0 20px;
}

.Cookie--message a {
  color: black;
  text-decoration: none;
}

/* 
*   Button
*/
.Cookie-Button-Accept {
  margin: 15px auto;
  /*background: linear-gradient(-90deg, #00919B 0%, #00AEB0 50%);*/
}

.Cookie-Button-Refuse {
  margin: auto;
  cursor: pointer;
  max-width: 190px;
}

.Cookie-Button-Accept a p {
}

.Cookie-Button-Accept a, .Cookie-Button-Refuse a {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.Cookie-Button-Refuse a p {
  margin-left: 20px;
  text-transform: uppercase;
  font-size: 10px;
  color: black;
}

.Cookie-Button-Refuse a p:before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 500px;
  background: rgba(193, 193, 193, 0.5);
  position: absolute;
  margin: 4px 0 0 -14px;
}

.Button {
  background-color: #00AEB0;
  border: 1px solid #00AEB0;
  border-radius: 50px;
  cursor: pointer;
  color: #FFFFFF;
  text-decoration: none;
  text-transform: uppercase;
  padding: 8px 30px;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
}

@media (max-width: 650px) {
  .Cookie {
    left: 25px;
    bottom: 25px;
    max-width: none;
    width: calc(100% - 50px);

    margin-left: 0; /* width and padding */
    padding: 20px 0;
  }
}

@media (max-width: 400px) {
  .Cookie--button img {
    display: none;
  }
}
</style>